<template>
	<div class="row dynvibeRow">
		<div class="col-lg-12">
			<div class="dynvibeBox">
				<div class="col-lg-12 dynvibeTitleBox"><h2>Top 100</h2></div>
				<div class="row dynvibeRow">
					<div class="col-lg-12">
						<p class="text-right helper-table" @click="reset">Reset tab</p>
						<table class="table dynvibeTable">
							<thead>
								<tr>
									<th class="col-special-1 no-sort">#</th>
									<th class="col-special-2" @click="fakeOrderPosition('position')">Position</th>
									<th class="col-special-2" @click="orderBy('name')">{{ level }}</th>
									<th class="col-special-1">
										<img class="flame-img" src="/img/flame.png" @click="orderBy('flame')" />
									</th>
									<th class="col-special-1">
										<img class="lightning-img" src="/img/lightning.png" @click="orderBy('lightning')" />
									</th>

									<th class="text-center col-special-4 no-sort">Profiles</th>
									<th class="text-center col-special-4 no-sort">Posts</th>

									<th class="text-center col-special-3 no-sort">Engagement</th>

									<th class="col-special-2 no-sort">Countries</th>
								</tr>
								<tr>
									<th class="col-special-7 no-sort">&nbsp;</th>
									<th class="col-special-2" @click="orderBy('diffusion')">Evolution</th>
									<th class="col-special-1" @click="orderBy('count_profiles')">Count</th>
									<th class="col-special-1" @click="orderBy('percent_profiles')">%</th>

									<th class="col-special-2" @click="orderBy('augmentation')">Evolution</th>
									<th class="col-special-1" @click="orderBy('count_posts')">Count</th>
									<th class="col-special-1" @click="orderBy('percent_posts')">%</th>

									<th class="col-special-2" @click="orderBy('engagement')">Evol</th>
									<th class="col-special-1" @click="orderBy('engagement')">%</th>
									<th class="col-special-2 no-sort">&nbsp;</th>
								</tr>
							</thead>
							<tbody v-if="allData.length > 0">
								<tr v-for="(line, index) in allData" :key="index">
									<td class="col-special-1" scope="row">{{ index + 1 }}</td>
									<td class="col-special-2">
										<span v-if="line[1] > 0" class="evolution">
											<i class="icon-arrow-growth"></i>
											+{{ line[1] }}
										</span>
										<span v-else-if="line[1] < 0" class="evolution">
											<i class="icon-arrow-descent"></i>
											{{ line[1] }}
										</span>
										<span v-else> - </span>
									</td>
									<td class="col-special-2">
										<a class="mastertag" @click="openTopic(line[2])">
											{{ line[2] }}
										</a>
									</td>
									<td class="col-special-1">
										<img v-if="line[3] > 30" class="flame-img" src="/img/flame.png" />
										<span class="debug">{{ line[3] }} </span>
									</td>
									<td class="col-special-1">
										<img v-if="line[4] > 30" class="lightning-img" src="/img/lightning.png" />
										<span class="debug">{{ line[4] }} </span>
									</td>

									<td class="col-special-2">
										<span class="evolution" v-if="line[5].evolution !== 0">
											<i v-if="line[5].evolution > 0" class="icon-arrow-growth"></i>
											<i v-else-if="line[5].evolution < 0" class="icon-arrow-descent"></i>

											{{ line[5].evolution > 0 ? "+" + line[5].evolution : line[5].evolution }}%
										</span>
										<span v-else> - </span>
									</td>
									<td class="col-special-1">
										<span>{{ line[5].value }} </span>
									</td>
									<td class="col-special-1">{{ Math.round(line[6]) }} %</td>
									<td class="col-special-2">
										<span class="evolution" v-if="line[7].evolution !== 0">
											<i v-if="line[7].evolution > 0" class="icon-arrow-growth"></i>
											<i v-else-if="line[7].evolution < 0" class="icon-arrow-descent"></i>

											{{ line[7].evolution > 0 ? "+" + line[7].evolution : line[7].evolution }}%
										</span>
										<span v-else> - </span>
									</td>
									<td class="col-special-1">
										<span>{{ line[7].value }} </span>
									</td>
									<td class="col-special-1">{{ Math.round(line[8]) }} %</td>
									<td class="col-special-2">
										<span class="evolution" v-if="line[9].evolution !== 0">
											<i v-if="line[9].evolution > 0" class="icon-arrow-growth"></i>
											<i v-else-if="line[9].evolution < 0" class="icon-arrow-descent"></i>

											{{ line[9].evolution > 0 ? "+" + line[9].evolution : line[9].evolution }}%
										</span>
										<span v-else> - </span>
									</td>
									<td class="col-special-1">
										<span>{{ Math.round(line[9].value) }} </span>
									</td>
									<td class="col-special-2">
										<div v-for="(country, index) in line[10]" :key="index">
											<span
												v-if="country.key !== ''"
												:class="[isDominantCountry(line[10], index) ? 'countryDominant' : '', 'country']"
											>
												{{ country.key }}
											</span>
										</div>
									</td>
								</tr>
							</tbody>
							<tbody v-if="!loading && allData.length === 0">
								<tr class="noData">
									<td colspan="11">No Data to display</td>
								</tr>
							</tbody>
							<div v-if="loading" class="col-lg-12 dynvibeLoading"></div>
						</table>
						<p class="text-right helper-table" v-if="!loading && canShowMore" @click="loadMore">Show more</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Top100",
	emits: ["clicked"],
	props: {
		level: {
			type: String,
			default: "",
		},
		filters: {
			type: Object,
			default: function () {
				return {};
			},
		},
		//old

		/*anydate: {
			default: false,
		},*/
	},
	data() {
		return {
			hidden: true,
			loading: false,
			rawData: [],
			allData: [],
			sort: {
				field: "ranking",
				order: "desc",
			},
			sortFrom: 0,
			sortSize: 100,
			append: false,
			canShowMore: true,
			totalPosts: 0,
			totalProfiles: 0,
			showModal: false,
			positionLast: [],
			positionPrevious: [],

			// old
			//results: [],
			//type: "people",
			//modalLabel: "",
		};
	},
	components: {},
	methods: {
		isDominantCountry(array, index) {
			let sum = 0;
			for (let i = 0; i < array.length; i++) {
				if (array[i].key === "") {
					continue;
				}
				sum += array[i].doc_count;
			}
			return array[index].doc_count / sum > 0.5;
		},
		/*roundToTwoDecimal(num) {
			if (!num) {
				num = 0;
			}
			return +(Math.round(num + "e+2") + "e-2");
		},*/
		getPercentagePosts(count) {
			return (count / this.totalPosts) * 100;
		},
		getPercentageProfiles(count) {
			return (count / this.totalProfiles) * 100;
		},
		loadComponent() {
			this.getPosition();
			this.checkFilters();
		},
		treatResponse(response) {
			if (!response.data.results || response.data.results.length === 0) {
				this.canShowMore = false;
				this.loading = false;
				return;
			}
			this.allData = [];
			if (!this.append) {
				this.rawData = [];
			}

			this.totalPosts = response.data.totalPosts;
			this.totalProfiles = response.data.totalProfiles;

			this.rawData = [...this.rawData, ...response.data.results]; // merge
			this.sortFrom = parseInt(response.data.sortFrom);
			for (let i = 0; i < this.rawData.length; i++) {
				this.allData.push([]);
			}

			this.loading = false;
			this.dataCompute();
		},
		checkFilters() {
			/*for (let i = 0; i < this.languageslist.length; i++) {
				if (this.languageslist[i]["country"] == this.trendfilters.country.name) {
					this.filters.lang = this.languageslist[i]["language"];
				}
			}*/
			this.hidden = false;
			this.loading = true;

			let params = {
				data: {
					level: this.level,
					sort: this.sort,
					sortFrom: this.sortFrom,
					sortSize: this.sortSize,
				},
				parameters: { ...this.filters },
			};

			this.getData("top100", params);
		},
		getPosition() {
			let params = {
				data: {
					level: this.level,
					sort: { field: "ranking", order: "desc" },
				},
				parameters: { ...this.filters },
			};
			this.$axios
				.get(this.$backendUrl + "top100Position", {
					params: params,
					paramsSerializer: (params) => {
						return this.$Qs.stringify(params, { arrayFormat: "brackets" });
					},
				})
				.then((response) => {
					this.positionLast = response.data.positionLast;
					this.positionPrevious = response.data.positionPrevious;
				});
		},
		orderBy(column) {
			this.append = false;
			this.allData = [];
			this.rawData = [];
			this.sortFrom = 0;
			this.sortSize = 100;
			this.canShowMore = true;

			if (this.sort.field === column) {
				this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
			} else {
				this.sort.field = column;
				this.sort.order = "desc";
			}
			this.checkFilters();
		},
		fakeOrderPosition(column) {
			this.loading = true;
			// fake order because it's only a JS sort (no axios call)
			if (this.sort.field === column) {
				this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
			} else {
				this.sort.field = column;
				this.sort.order = "desc";
			}

			if (this.sort.order === "desc") {
				this.allData.sort((a, b) => a[1] - b[1]);
			} else {
				this.allData.sort((a, b) => b[1] - a[1]);
			}
			this.loading = false;
		},
		dataCompute() {
			for (let i = 0; i < this.rawData.length; i++) {
				let evolution = this.rawData[i]["evolution"]["buckets"];
				let flame = 0;

				let evolution_previous = evolution[0]["doc_count"];
				let evolution_last = evolution[1]["doc_count"];

				let buckets = this.rawData[i]["date_range"]["buckets"];

				let bucketDocCount0 = buckets[0]["doc_count"];
				let bucketDocCount1 = buckets[1]["doc_count"];
				let bucketProfiles0 = buckets[0]["count"]["value"];
				let bucketProfiles1 = buckets[1]["count"]["value"];
				let bucketImpact0 = buckets[0]["impact_score_fixed"]["value"];
				let bucketImpact1 = buckets[1]["impact_score_fixed"]["value"];

				// prevent division by 0
				bucketDocCount0 = bucketDocCount0 === 0 ? 1 : bucketDocCount0;
				bucketProfiles0 = bucketProfiles0 === 0 ? 1 : bucketProfiles0;
				//bucketProfiles1 = bucketProfiles1 === 0 ? 1 : bucketProfiles1;
				bucketImpact0 = bucketImpact0 === 0 ? 1 : bucketImpact0;
				//bucketImpact1 = bucketImpact1 === 0 ? 1 : bucketImpact1;

				// #
				this.allData[i][0] = i;

				// Position
				let indexLast = this.positionLast.indexOf(this.rawData[i]["key"]);
				let indexPrevious = this.positionPrevious.indexOf(this.rawData[i]["key"]);
				if (this.sort.field !== "ranking" || indexLast === -1 || indexPrevious === -1) {
					this.allData[i][1] = 0;
				} else {
					this.allData[i][1] = indexPrevious - indexLast;
				}

				//Mastertag
				this.allData[i][2] = this.rawData[i]["key"];

				// Flame (last month, last month -1)
				if (evolution_previous !== 0) {
					flame = Math.round(((evolution_last - evolution_previous) / evolution_previous) * 100);
				}
				this.allData[i][3] = flame;

				// Lightning
				let ln = 0;
				if (bucketProfiles1 !== 0) {
					ln = bucketDocCount1 / bucketProfiles1;
				}

				let ln_1 = 0;
				if (bucketProfiles0 !== 0 && bucketDocCount0 !== 0) {
					ln_1 = bucketDocCount0 / bucketProfiles0;
				}

				this.allData[i][4] = Math.round(ln - ln_1);

				// profiles
				let aug = Math.round(((bucketProfiles1 - bucketProfiles0) / bucketProfiles0) * 100);
				this.allData[i][5] = { evolution: aug, value: buckets[1]["count"]["value"] };
				this.allData[i][6] = this.getPercentageProfiles(buckets[1]["count"]["value"]);

				// posts
				aug = Math.round(((bucketDocCount1 - bucketDocCount0) / bucketDocCount0) * 100);
				this.allData[i][7] = { evolution: aug, value: bucketDocCount1 };
				this.allData[i][8] = this.getPercentagePosts(bucketDocCount1);

				// engagement
				aug = Math.round(((bucketImpact1 - bucketImpact0) / bucketImpact0) * 100);
				this.allData[i][9] = { evolution: aug, value: buckets[1]["impact_score"]["value"] };

				// countries
				this.allData[i][10] = this.rawData[i]["countries"]["buckets"];
			}
		},
		loadMore() {
			//this.sortFrom += this.sortSize;
			this.append = true;
			this.checkFilters();
		},
		reset() {
			this.rawData = [];
			this.allData = [];
			this.sort = {
				field: "ranking",
				order: "desc",
			};
			this.sortFrom = 0;
			this.sortSize = 100;
			this.append = false;
			this.canShowMore = true;
			this.checkFilters();
		},
		openTopic(item) {
			this.$emit("clicked", { keyword: item, level: "mastertag" });
		},
	},
	watch: {
		filters: {
			handler() {
				this.getPosition();
				this.reset();
			},
			deep: true,
			immediate: true,
		},

		"$store.getters.parameters": function () {
			this.type = this.$store.getters.parameters.tagclass;
			this.loadComponent(this.$store.getters.parameters);
		},
		showModal: function () {
			// if (this.showModal === false) store.dispatch('setMastertagTop100', '')
		},
	},
};
</script>
<style scoped>
.col-special-1 {
	width: 5%;
}

.col-special-2 {
	width: 10%;
}

.col-special-3 {
	width: 15%;
}

.col-special-4 {
	width: 20%;
}

.col-special-6 {
	width: 30%;
}

.col-special-7 {
	width: 35%;
}
img.dynvibeArrayTopImg {
	width: 40px;
	height: 40px;
}

thead {
	width: 100%;
}

table.dynvibeTable tr th {
	cursor: pointer;
}

.no-sort {
	cursor: default !important;
}

table th img {
	filter: grayscale(100%);
}

table {
	display: flex;
	flex-flow: column;
	width: 100%;
}

thead {
	flex: 0 0 auto;
}

tbody {
	flex: 1 1 auto;
	display: block;
	overflow-y: overlay;
	overflow-x: hidden;
}

tr {
	width: 100%;
	display: table;
	table-layout: fixed;
}

table tr img {
	height: 24px;
	width: 24px;
}

thead > p,
tfoot p {
	text-align: right;
	text-decoration: underline;
	cursor: pointer;
	text-transform: capitalize;
}

.dynvibeTable td,
.dynvibeTable th {
	float: none !important;
	vertical-align: top;
}

.helper-table {
	text-decoration: underline;
	cursor: pointer;
}

.noData {
	font-family: "Montserrat";
	text-align: center;
	text-transform: none;
	font-size: 22px;
	font-weight: 400;
	font-style: italic;
	color: #9e9e9e;
	margin-top: 18 px;
}

.evolution {
	font-size: 16px;
	margin-right: 10px;
}

.country {
	background-color: #dadada;
	text-transform: uppercase;
	padding: 5px;
	margin: 3px;
	float: left;
}

.countryDominant {
	background-color: rgba(35, 5, 107, 0.7);
	color: #fff;
}

.mastertag {
	cursor: pointer;
}

.debug {
	font-size: 10px;
}
</style>
